export default __webpack_public_path__ + "static/media/nyloc-985-zinc.5eae778b.webp";